import {
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
  toString1n9qg6fb0b5i8 as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractEncoder.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Composer1pt8hwk95abxi as Composer,
  ComposerForUnquotedLiterals3v0rwxdudtla9 as ComposerForUnquotedLiterals,
  ComposerForUnsignedNumbers2h1dv6l9z3aef as ComposerForUnsignedNumbers,
} from './Composers.mjs';
import { AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/AbstractPolymorphicSerializer.mjs';
import {
  CLASS_getInstance3jy3ydw5832xx as CLASS_getInstance,
  OBJECT_getInstancerq52wx6ymebx as OBJECT_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ClassDiscriminatorMode_NONE_getInstance30klgvxbw1mx1 as ClassDiscriminatorMode_NONE_getInstance } from '../JsonConfiguration.mjs';
import {
  classDiscriminator9fd3hvqsgfqq as classDiscriminator,
  subtypeNotRegisteredMessageJson3mtuvvd9idjxz as subtypeNotRegisteredMessageJson,
  access$checkEncodingConflicts$tJsonPolymorphicHelpersKtlxbuf8m1156u as access$checkEncodingConflicts$tJsonPolymorphicHelpersKt,
  checkKind2e7hdnuk9c0tp as checkKind,
} from './JsonPolymorphicHelpers.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { JsonEncodingException3vzv9k0f9l05u as JsonEncodingException } from '../JsonExceptions.mjs';
import { SerializationStrategyh6ouydnm6hci as SerializationStrategy } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { modeFort67zb8ch2jog as modeFor } from './LexerMode.mjs';
import { getJsonElementName36ciq3w3g8x0l as getJsonElementName } from './JsonNamesMap.mjs';
import { InvalidFloatingPointEncoded1h6zoomba5tnf as InvalidFloatingPointEncoded } from './JsonExceptions.mjs';
import {
  isFinite1tx0gn65nl9tj as isFinite,
  isFinite2t9l5a275mxm6 as isFinite_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
import { JsonEncoder1qlse6simkfi1 as JsonEncoder } from '../JsonEncoder.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { get_jsonUnquotedLiteralDescriptors6ipxyp7dsvf as get_jsonUnquotedLiteralDescriptor } from '../JsonElement.mjs';
import { Companion_getInstance1crempiiqys0g as Companion_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import {
  serializer3ikrxnm8b29d6 as serializer,
  serializer2lw83vwvpnyms as serializer_0,
  serializer36584sjyg5661 as serializer_1,
  serializer1q7c5q67ysppr as serializer_2,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { Companion_getInstance11ies3wlxhmd7 as Companion_getInstance_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import { Companion_getInstanceb1xi7131i8df as Companion_getInstance_1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import { Companion_getInstance1foc7f9q9rk1s as Companion_getInstance_2 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_unsignedNumberDescriptors() {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return unsignedNumberDescriptors;
}
var unsignedNumberDescriptors;
function encodeTypeInfo($this, discriminator, serialName) {
  $this.h2v_1.i2t();
  $this.x1s(discriminator);
  $this.h2v_1.l2t(_Char___init__impl__6a9atx(58));
  $this.h2v_1.k2t();
  $this.x1s(serialName);
}
var StreamingJsonEncoderClass;
function StreamingJsonEncoder() {
  if (StreamingJsonEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      constructor(composer, json, mode, modeReuseCache) {
        return new.target.z2w(composer, json, mode, modeReuseCache);
      }
      static z2w(composer, json, mode, modeReuseCache) {
        var $this = this.l1s();
        $this.h2v_1 = composer;
        $this.i2v_1 = json;
        $this.j2v_1 = mode;
        $this.k2v_1 = modeReuseCache;
        $this.l2v_1 = $this.i2v_1.h1s();
        $this.m2v_1 = $this.i2v_1.i2o_1;
        $this.n2v_1 = false;
        $this.o2v_1 = null;
        $this.p2v_1 = null;
        var i = $this.j2v_1.w1_1;
        if (!($this.k2v_1 == null)) {
          if (!($this.k2v_1[i] === null) || !($this.k2v_1[i] === $this)) {
            $this.k2v_1[i] = $this;
          }
        }
        return $this;
      }
      p2q() {
        return this.i2v_1;
      }
      static q2v(output, json, mode, modeReuseCache) {
        return this.z2w(Composer(output, json), json, mode, modeReuseCache);
      }
      h1s() {
        return this.l2v_1;
      }
      q1t(descriptor, index) {
        return this.m2v_1.w2p_1;
      }
      l1t(serializer, value) {
        // Inline function 'kotlinx.serialization.json.internal.withExceptionHandling' call
        var tmp;
        try {
          $l$block: {
            // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
            if (this.p2q().i2o_1.e2q_1) {
              serializer.c1n(this, value);
              break $l$block;
            }
            var isPolymorphicSerializer = serializer instanceof AbstractPolymorphicSerializer();
            var tmp_0;
            if (isPolymorphicSerializer) {
              tmp_0 = !this.p2q().i2o_1.m2q_1.equals(ClassDiscriminatorMode_NONE_getInstance());
            } else {
              var tmp_1;
              switch (this.p2q().i2o_1.m2q_1.w1_1) {
                case 0:
                case 2:
                  tmp_1 = false;
                  break;
                case 1:
                  // Inline function 'kotlin.let' call

                  var it = serializer.b1n().x1p();
                  tmp_1 = equals(it, CLASS_getInstance()) || equals(it, OBJECT_getInstance());
                  break;
                default:
                  noWhenBranchMatchedException();
                  break;
              }
              tmp_0 = tmp_1;
            }
            var needDiscriminator = tmp_0;
            var baseClassDiscriminator = needDiscriminator ? classDiscriminator(serializer.b1n(), this.p2q()) : null;
            var tmp_2;
            if (isPolymorphicSerializer) {
              var casted = serializer instanceof AbstractPolymorphicSerializer() ? serializer : THROW_CCE();
              $l$block_0: {
                // Inline function 'kotlin.requireNotNull' call
                if (value == null) {
                  var message = 'Value for serializer ' + toString_0(serializer.b1n()) + ' should always be non-null. Please report issue to the kotlinx.serialization tracker.';
                  throw IllegalArgumentException().o2(toString_0(message));
                } else {
                  break $l$block_0;
                }
              }
              var tmp1_elvis_lhs = casted.v1n(this, value);
              var tmp_3;
              if (tmp1_elvis_lhs == null) {
                // Inline function 'kotlin.run' call
                var tmp0_elvis_lhs = getKClassFromExpression(value).j1();
                var subClassName = tmp0_elvis_lhs == null ? toString_0(getKClassFromExpression(value)) : tmp0_elvis_lhs;
                var _destruct__k2r9zo = subtypeNotRegisteredMessageJson(subClassName, casted.s1n());
                var message_0 = _destruct__k2r9zo.df();
                var hint = _destruct__k2r9zo.ef();
                throw JsonEncodingException().d2t(message_0, subClassName, hint);
              } else {
                tmp_3 = tmp1_elvis_lhs;
              }
              var actual = tmp_3;
              tmp_2 = isInterface(actual, SerializationStrategy()) ? actual : THROW_CCE();
            } else {
              tmp_2 = serializer;
            }
            var actualSerializer = tmp_2;
            if (!(baseClassDiscriminator == null)) {
              access$checkEncodingConflicts$tJsonPolymorphicHelpersKt(this.p2q(), serializer, actualSerializer, baseClassDiscriminator);
              checkKind(actualSerializer.b1n().x1p());
              var serialName = actualSerializer.b1n().e1o();
              this.o2v_1 = baseClassDiscriminator;
              this.p2v_1 = serialName;
            }
            actualSerializer.c1n(this, value);
          }
          tmp = Unit_instance;
        } catch ($p) {
          var tmp_4;
          if ($p instanceof SerializationException()) {
            var e = $p;
            throw e;
          } else {
            if ($p instanceof Exception()) {
              var e_0 = $p;
              var causeMessage = e_0.message;
              var classSerialName = serializer.b1n().e1o();
              var message_1 = 'Serialization ' + (isBlank(classSerialName) ? '' : "of '" + classSerialName + "' ") + 'failed because of ' + (causeMessage == null ? 'an exception' : "'" + causeMessage + "' exception") + ' in the encoder';
              throw JsonEncodingException().d2t(message_1, classSerialName, VOID, e_0);
            } else {
              throw $p;
            }
          }
        }
        return tmp;
      }
      s1r(descriptor) {
        var newMode = modeFor(this.i2v_1, descriptor);
        if (!(newMode.f2w_1 === _Char___init__impl__6a9atx(0))) {
          this.h2v_1.l2t(newMode.f2w_1);
          this.h2v_1.g2t();
        }
        var discriminator = this.o2v_1;
        if (!(discriminator == null)) {
          var tmp0_elvis_lhs = this.p2v_1;
          encodeTypeInfo(this, discriminator, tmp0_elvis_lhs == null ? descriptor.e1o() : tmp0_elvis_lhs);
          this.o2v_1 = null;
          this.p2v_1 = null;
        }
        if (this.j2v_1.equals(newMode)) {
          return this;
        }
        var tmp1_safe_receiver = this.k2v_1;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver[newMode.w1_1];
        return tmp2_elvis_lhs == null ? StreamingJsonEncoder().z2w(this.h2v_1, this.i2v_1, newMode, this.k2v_1) : tmp2_elvis_lhs;
      }
      t1r(descriptor) {
        if (!(this.j2v_1.g2w_1 === _Char___init__impl__6a9atx(0))) {
          this.h2v_1.h2t();
          this.h2v_1.j2t();
          this.h2v_1.l2t(this.j2v_1.g2w_1);
        }
      }
      m1s(descriptor, index) {
        switch (this.j2v_1.w1_1) {
          case 1:
            if (!this.h2v_1.f2t_1) {
              this.h2v_1.l2t(_Char___init__impl__6a9atx(44));
            }

            this.h2v_1.i2t();
            break;
          case 2:
            if (!this.h2v_1.f2t_1) {
              var tmp = this;
              var tmp_0;
              if ((index % 2 | 0) === 0) {
                this.h2v_1.l2t(_Char___init__impl__6a9atx(44));
                this.h2v_1.i2t();
                tmp_0 = true;
              } else {
                this.h2v_1.l2t(_Char___init__impl__6a9atx(58));
                this.h2v_1.k2t();
                tmp_0 = false;
              }
              tmp.n2v_1 = tmp_0;
            } else {
              this.n2v_1 = true;
              this.h2v_1.i2t();
            }

            break;
          case 3:
            if (index === 0)
              this.n2v_1 = true;
            if (index === 1) {
              this.h2v_1.l2t(_Char___init__impl__6a9atx(44));
              this.h2v_1.k2t();
              this.n2v_1 = false;
            }

            break;
          default:
            if (!this.h2v_1.f2t_1) {
              this.h2v_1.l2t(_Char___init__impl__6a9atx(44));
            }

            this.h2v_1.i2t();
            this.x1s(getJsonElementName(descriptor, this.i2v_1, index));
            this.h2v_1.l2t(_Char___init__impl__6a9atx(58));
            this.h2v_1.k2t();
            break;
        }
        return true;
      }
      m1t(descriptor, index, serializer, value) {
        if (!(value == null) || this.m2v_1.b2q_1) {
          super.m1t(descriptor, index, serializer, value);
        }
      }
      z1s(descriptor) {
        var tmp;
        if (get_isUnsignedNumber(descriptor)) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
          var tmp_0;
          var tmp_1 = this.h2v_1;
          if (tmp_1 instanceof ComposerForUnsignedNumbers()) {
            tmp_0 = this.h2v_1;
          } else {
            var tmp0 = this.h2v_1.e2t_1;
            var p1 = this.n2v_1;
            tmp_0 = new (ComposerForUnsignedNumbers())(tmp0, p1);
          }
          var tmp$ret$0 = tmp_0;
          tmp = StreamingJsonEncoder().z2w(tmp$ret$0, this.i2v_1, this.j2v_1, null);
        } else if (get_isUnquotedLiteral(descriptor)) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
          var tmp_2;
          var tmp_3 = this.h2v_1;
          if (tmp_3 instanceof ComposerForUnquotedLiterals()) {
            tmp_2 = this.h2v_1;
          } else {
            var tmp0_0 = this.h2v_1.e2t_1;
            var p1_0 = this.n2v_1;
            tmp_2 = new (ComposerForUnquotedLiterals())(tmp0_0, p1_0);
          }
          var tmp$ret$2 = tmp_2;
          tmp = StreamingJsonEncoder().z2w(tmp$ret$2, this.i2v_1, this.j2v_1, null);
        } else if (!(this.o2v_1 == null)) {
          // Inline function 'kotlin.apply' call
          this.p2v_1 = descriptor.e1o();
          tmp = this;
        } else {
          tmp = super.z1s(descriptor);
        }
        return tmp;
      }
      o1s() {
        this.h2v_1.n2t('null');
      }
      p1s(value) {
        if (this.n2v_1) {
          this.x1s(value.toString());
        } else {
          this.h2v_1.w2t(value);
        }
      }
      q1s(value) {
        if (this.n2v_1) {
          this.x1s(value.toString());
        } else {
          this.h2v_1.r2t(value);
        }
      }
      r1s(value) {
        if (this.n2v_1) {
          this.x1s(value.toString());
        } else {
          this.h2v_1.t2t(value);
        }
      }
      s1s(value) {
        if (this.n2v_1) {
          this.x1s(value.toString());
        } else {
          this.h2v_1.u2t(value);
        }
      }
      t1s(value) {
        if (this.n2v_1) {
          this.x1s(value.toString());
        } else {
          this.h2v_1.v2t(value);
        }
      }
      u1s(value) {
        if (this.n2v_1) {
          this.x1s(value.toString());
        } else {
          this.h2v_1.p2t(value);
        }
        if (!this.m2v_1.g2q_1 && !isFinite(value)) {
          throw InvalidFloatingPointEncoded(value);
        }
      }
      v1s(value) {
        if (this.n2v_1) {
          this.x1s(value.toString());
        } else {
          this.h2v_1.q2t(value);
        }
        if (!this.m2v_1.g2q_1 && !isFinite_0(value)) {
          throw InvalidFloatingPointEncoded(value);
        }
      }
      w1s(value) {
        this.x1s(toString(value));
      }
      x1s(value) {
        return this.h2v_1.x2t(value);
      }
      y1s(enumDescriptor, index) {
        this.x1s(enumDescriptor.b1q(index));
      }
    }
    initMetadataForClass($, 'StreamingJsonEncoder', VOID, VOID, [JsonEncoder()]);
    StreamingJsonEncoderClass = $;
  }
  return StreamingJsonEncoderClass;
}
function get_isUnsignedNumber(_this__u8e3s4) {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return _this__u8e3s4.y1p() && get_unsignedNumberDescriptors().t2(_this__u8e3s4);
}
function get_isUnquotedLiteral(_this__u8e3s4) {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return _this__u8e3s4.y1p() && equals(_this__u8e3s4, get_jsonUnquotedLiteralDescriptor());
}
var properties_initialized_StreamingJsonEncoder_kt_6ifwwk;
function _init_properties_StreamingJsonEncoder_kt__pn1bsi() {
  if (!properties_initialized_StreamingJsonEncoder_kt_6ifwwk) {
    properties_initialized_StreamingJsonEncoder_kt_6ifwwk = true;
    unsignedNumberDescriptors = setOf([serializer(Companion_getInstance()).b1n(), serializer_0(Companion_getInstance_0()).b1n(), serializer_1(Companion_getInstance_1()).b1n(), serializer_2(Companion_getInstance_2()).b1n()]);
  }
}
//region block: exports
export {
  StreamingJsonEncoder as StreamingJsonEncoder1wswwd0g47gwe,
  get_isUnsignedNumber as get_isUnsignedNumber3dxwaa3af8ncr,
};
//endregion

//# sourceMappingURL=StreamingJsonEncoder.mjs.map
